/**
 * Boolean Formatter.
 * @param {*} value
 * @returns {*}
 */
window.booleanFormatter = function(value) {
    if (value === 1 || value === "TRUE") {
        return '<i class="fa fa-check text-success"></i>';
    }
};
